import React, { Component, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { RegisterAuthAction } from '../../../redux/actions/AuthAction';
import { ResetErrorHandlerAction } from '../../../redux/actions/ErrorActions';
import '../../../styles/mainContents.css';

function Register(props) {

    const { Register, resetErrorHandler } = props;
    const [ registerState, setRegisterState ] = useState({});
    const history = useHistory();

    return (
                
        <div>
            <main>
                <h1>Register</h1>

                <div>
                    <label>Name</label>    
                    <input 
                        type="text" 
                        placeholder='Name'
                        id='iRegisterName' 
                        onChange={(event) => {
                            const name = event.target.value;
                            setRegisterState({...registerState, ...{name}});
                        }}
                    />
                </div> 

                <div>
                    <label>Username</label>
                    <input 
                        type="text" 
                        placeholder='Username'
                        id='iRegisterUsername' 
                        onChange={(event) => {
                            const username = event.target.value;
                            setRegisterState({...registerState, ...{username}});
                        }}    
                    />
                </div>


                <div>
                    <label>Email address</label>    
                    <input 
                        type="email" 
                        placeholder='Email Address'
                        id='iRegisterUserEmail' 
                        onChange={(event) => {
                            const email = event.target.value;
                            setRegisterState({...registerState, ...{email}});
                        }}
                    />
                </div> 

                <div>
                    <label>Password</label>
                    <input 
                        type="password" 
                        placeholder='Password'
                        id='iRegisterUserPass' 
                        onChange={(event) => {
                            const password = event.target.value;
                            setRegisterState({...registerState, ...{password}});
                        }}    
                    />
                </div>

                <div id='registerBtnDivId'>
                    <div>
                        <button onClick={() => {
                            resetErrorHandler()
                            history.push('/login')
                        }}>Back to Login
                        </button>
                    </div>                    
                    <div>
                        <button onClick={() => {
                            //FOR PYTHON Register METHOD
                            Register(registerState, history);
                        }}>Register Account
                        </button>
                    </div>
                </div>


            </main>

        </div>


    );
}

const mapStateToProps = (state) => {
    return {
        //RegisterState: state.authreducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        Register: (registerState, history) => {
            dispatch(RegisterAuthAction(registerState, history));
        },
        resetErrorHandler: () => {
            dispatch(ResetErrorHandlerAction());
        }                    
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);